import axios from 'axios';
import { CommonState, error, isFetching } from './common';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { enqueueRequestErrorSnackbar } from '../actions/enqueueSnackbar';

const name = 'oshaViolations';

export enum OshaVerificationStatus {
  NoViolations,
  Pending,
  ViolationsFound
}

type IVerificationStatus = {
  verificationStatus: OshaVerificationStatus;
};

export const fetchOshaVerificationStatus = createAsyncThunk(
  `${name}/fetch`,
  async ({ organizationId }: { organizationId: string }, { dispatch }) => {
    try {
      const {
        data: { verificationStatus }
      } = await axios.get<IVerificationStatus>(
        `/api/v3.1/organizations/${organizationId}/organizationViolationSummary`
      );

      return verificationStatus;
    } catch (error) {
      dispatch(enqueueRequestErrorSnackbar());
      throw error;
    }
  }
);

export type State = CommonState & {
  verificationStatus: OshaVerificationStatus | null;
};

const initialState: State = {
  verificationStatus: null,
  isFetching: false,
  error: null
};

const oshaViolations = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchOshaVerificationStatus.pending, isFetching)
      .addCase(fetchOshaVerificationStatus.fulfilled, (state, action) => {
        state.verificationStatus = action.payload;
        state.isFetching = false;
      })
      .addCase(fetchOshaVerificationStatus.rejected, error);
  }
});

export const { reducer: oshaViolationsReducer } = oshaViolations;
